module.exports = __webpack_public_path__ + "img/clock.57667d57.png";